import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/api';
import { QuarterNameConfigGateway } from 'src/app/application/gateway/QuarterNameConfigGateway';
import { CreateQuarterNameConfigRequest, QuarterNameConfig, QuarterNameConfigsResponse } from 'src/app/domain/models/QuarterNameConfig';

@Component({
  selector: 'app-quarter-name-config-form',
  templateUrl: './quarter-name-config-form.component.html',
  styleUrls: ['./quarter-name-config-form.component.css']
})
export class QuarterNameConfigFormComponent implements OnInit, OnChanges {

  quarterConfig: QuarterNameConfigsResponse = {
    quarterCodes: [],
    quarterNames: [],
    varietyCodes: [],
    realVarietyNames: [],
    config: {}
  }


  quarterConfigOptions: SelectItem[] = [
    {
      label: "Quarter Name",
      value: 0
    },
    {
      label: "Quarter Code",
      value: 1
    },
    {
      label: "Variety Name",
      value: 2
    },
    {
      label: "Variety Code",
      value: 3
    },
  ]

  @Input()
  stockId: number | undefined

  quarterNameConfigs: QuarterNameConfig[] = []
  loading: boolean = false;
  selectedConfigOption: number = 0;

  constructor(
    private quarterNameConfigService: QuarterNameConfigGateway,
    private _messageService: MessageService,
    public translate: TranslateService
  ){

  }

  ngOnInit(): void {
    this.getQuarterConfig()
  }

  ngOnChanges(changes: SimpleChanges): void {
        if(changes['stockId'])
    {
      this.getQuarterConfig()
    }
  }

  getQuarterConfig()
  {
    if(this.stockId)
    {
      this.loading = true;
      this.quarterNameConfigService.getConfigs(this.stockId).subscribe({
        next: (v) => {
          this.quarterConfig = v;
          this.setUpConfig();
          this.loading = false;
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.QuarterNameConfig.GetQuarterConfigError') });
        }
      })
    }

  }

  create()
  {
    let createQuarterNameConfigRequest:CreateQuarterNameConfigRequest =
    {
      quarterNameConfigs: this.quarterNameConfigs,
      stockId: this.stockId ?? 0
    }

    this.loading = true;

    this.quarterNameConfigService.create(createQuarterNameConfigRequest).subscribe({
      next: (v) =>
      {
        this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.QuarterNameConfig.CreateQuarterConfigSuccess') });
          this.loading = false;
      },
        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.QuarterNameConfig.CreateQuarterConfigError') });
            this.loading = false;
      }
    })
  }

  buildOptions(values:string[], keyValues: Record<string, string>)
  {
    this.quarterNameConfigs = [];
    values.forEach(element => {

      this.quarterNameConfigs.push({
        configValue: element,
        configName:  keyValues[element] ?? '',
        stockId: this.stockId,
        quarterNameConfigType: this.selectedConfigOption

      })

    });
  }

  setUpConfig()
  {
    switch(this.selectedConfigOption)
    {
      case 0:
        this.buildOptions(this.quarterConfig.quarterNames, this.quarterConfig.config);
        break;
      case 1:
        this.buildOptions(this.quarterConfig.quarterCodes, this.quarterConfig.config);
        break;
      case 2:
        this.buildOptions(this.quarterConfig.varietyCodes, this.quarterConfig.config);
        break;
      case 3:
        this.buildOptions(this.quarterConfig.realVarietyNames, this.quarterConfig.config);
        break;
    }

  }

}
